// extracted by mini-css-extract-plugin
export default {"calendar":"style_calendar__8jY16","disabled":"style_disabled__jfND1","label":"style_label__We0cP"};